import { useEffect } from "react";
import { derive } from "valtio/utils";

import { readState } from "@/__main__/app-state.mjs";
import globals from "@/util/global-whitelist.mjs";
import { useSnapshot } from "@/util/use-snapshot.mjs";

const derivedState = derive({
  disableAnimations: (get) => get(readState).settings.disableAnimations,
  hardwareAccelerationEnabled: (get) =>
    get(readState).volatile?.hardwareAcceleration?.enabled,
  isFocused: (get) => get(readState).volatile?.isFocused,
});

// The presence of `disable-animations` class on the document body should be the
// *ONLY SOURCE OF TRUTH* regarding animations in application kode.
//
// Do not try to read whether animations are disabled or not in JS code, because
// that will couple logic with animations.
//
// What the disable animations class does is just `animations: none !important;`
// and applies this globally. RELY ON THIS TO DISABLE ANIMATIONS GLOBALLY, DO NOT
// DISABLE/ENABLE ANIMATIONS LOCALLY. This also constrains animations to CSS,
// exceptions may only be made if there is an animation that requires JS to work,
// such as exit animations, and even then, those animations *must be disabled
// under the same condition above.*
function useDisableAnimations() {
  const { disableAnimations, hardwareAccelerationEnabled, isFocused } =
    useSnapshot(derivedState);

  useEffect(() => {
    const cls = "disable-animations";
    if (
      disableAnimations ||
      hardwareAccelerationEnabled === false ||
      isFocused === false
    )
      globals.document.body.classList.add(cls);
    else globals.document.body.classList.remove(cls);
  }, [disableAnimations, hardwareAccelerationEnabled, isFocused]);
}

export default useDisableAnimations;
